import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
// import { RevenueChartComponent } from './components/revenue-chart/revenue-chart.component';
// import { OccupancyRateChartComponent } from './components/occupancy-rate-chart/occupancy-rate-chart.component';
// import { GlobalCalendarComponent } from './components/global-calendar/global-calendar.component';
import { ReservationsUpdates } from './components/reservations-updates/reservations-updates.component';
import { SummaryCards } from './components/summary-cards/summary-cards.component';
import { withAuthorization } from '../../../shared/services/auth/with-authorization/with-authorization.component';
import { UserRole } from '../../../shared/enums/user-role.enum';

// import { PendingActionsComponent } from './components/pending-actions/pending-actions.component';

import { DoubleBookings } from './components/double-booking/double-booking.component';
import { NewGlobalCalendar } from './components/global-calendar/NewGlobalCalendar';
// import { CalendarIcon, SummaryIcon } from '../../../ui/Icons';

export const HomeContainer = () => {
  useEffect(() => trackPage('dashboard'), []);

  // const tabs = ['Summary', 'Calendar'] as const;
  // const [activeTab, setActiveTab] = useState<typeof tabs[number]>('Summary');

  // const iconByTab: Record<typeof tabs[number], JSX.Element> = {
  //   Summary: <SummaryIcon className="shrink-0" size="20px" />,
  //   Calendar: <CalendarIcon className="shrink-0" size="20px" />
  // };

  return (
    <div className="flex w-full flex-col items-start justify-start md:min-h-[calc(100vh-45px)] bg-creams-50 md:px-8 md:py-12">
      {/* <ol
        className="flex gap-3 justify-center items-center overflow-x-auto w-full p-1 mb-2"
        aria-label="Dashboard tabs"
      >
        {tabs.map((tabKey) => {
          const isActive = activeTab === tabKey;
          const baseClass =
            'inline-flex items-center gap-2 px-4 py-2 whitespace-nowrap rounded-lg cursor-pointer select-none transition-all duration-150 focus:outline-none focus:ring-2';
          const activeClass = 'bg-primary-600 text-white shadow-elevation-1 focus:ring-primary-300';
          const inactiveClass =
            'text-primary-700 hover:text-primary-600 hover:bg-primary-50 focus:ring-primary-100';

          return (
            <li key={tabKey}>
              <button
                type="button"
                aria-pressed={isActive}
                onClick={() => setActiveTab(tabKey)}
                className={`${baseClass} ${isActive ? activeClass : inactiveClass}`}
              >
                <span className={isActive ? 'text-white' : 'text-primary-600'}>
                  {iconByTab[tabKey]}
                </span>
                <span>{tabKey}</span>
              </button>
            </li>
          );
        })}
      </ol> */}

      <div className="flex-1 w-full rounded-xl transition-all ease-in-out duration-200">
        {/* <div
          className={activeTab === 'Summary' ? 'block' : 'hidden'}
          aria-hidden={activeTab !== 'Summary'}
        > */}
        <div className="my-4 text-[2.5rem] font-bold text-[#566346]"></div>

        <Summary />

        {/* <PendingSection /> */}
        <DoubleBookingSummary />
        <ReservationsSummary />
        {/* </div> */}

        {/* <div
          className={activeTab === 'Calendar' ? 'block' : 'hidden'}
          aria-hidden={activeTab !== 'Calendar'}
        > */}
        <div className="mb-12 w-full rounded-lg bg-white">
          {/* <GlobalCalendar /> */}
          <NewGlobalCalendarRender />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default connect()(HomeContainer);

// const OccupancyRate = withAuthorization(
//   [UserRole.ADMIN, UserRole.E_COMMERCE, UserRole.FINANCE_MANAGER],
//   true
// )(() => (
//   <div className="w-full rounded-lg bg-white py-8 md:w-[49%] md:m-2">
//     <OccupancyRateChartComponent />
//   </div>
// ));

// const MonthlyRevenue = withAuthorization(
//   [UserRole.ADMIN, UserRole.E_COMMERCE, UserRole.FINANCE_MANAGER],
//   true
// )(() => (
//   <div className="w-full rounded-lg bg-white py-8 md:w-[49%] md:m-2">
//     <RevenueChartComponent />
//   </div>
// ));

// const PendingSection = withAuthorization(
//   [
//     UserRole.E_COMMERCE,
//     UserRole.ECOMMERCE_SPECIALIST,
//     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
//     UserRole.SALES_SPECIALIST,
//     UserRole.SALES_MANAGER,
//     UserRole.ADMIN,
//     UserRole.SUPER_ADMIN,
//     UserRole.FINANCE_MANAGER,
//     UserRole.FINANCE_SPECIALIST,
//     UserRole.RESERVATION_MANAGER,
//     UserRole.RESERVATION_AGENT,
//     UserRole.RESERVATIONS,
//     UserRole.HOSPITALITY_AGENT,
//     UserRole.GES,
//     UserRole.HOSPITALITY_MANAGER,
//     UserRole.HOUSE_KEEPING_MANAGER,
//     UserRole.OPERATION_MANAGER,
//     UserRole.COMMERCIAL_MANAGER,
//     UserRole.INVESTOR
//   ],
//   true
// )(() => <PendingActionsComponent />);

const ReservationsSummary = withAuthorization(
  [
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <ReservationsUpdates />);

const Summary = withAuthorization(
  [UserRole.SUPER_ADMIN, UserRole.ADMIN],
  true
)(() => <SummaryCards />);

const DoubleBookingSummary = withAuthorization(
  [
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <DoubleBookings />);

// const GlobalCalendar = withAuthorization(
//   [
//     UserRole.E_COMMERCE,
//     UserRole.ECOMMERCE_SPECIALIST,
//     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
//     UserRole.SALES_SPECIALIST,
//     UserRole.SALES_MANAGER,
//     UserRole.ADMIN,
//     UserRole.FINANCE_MANAGER,
//     UserRole.FINANCE_SPECIALIST,
//     UserRole.RESERVATION_MANAGER,
//     UserRole.RESERVATION_AGENT,
//     UserRole.RESERVATIONS,
//     UserRole.HOSPITALITY_AGENT,
//     UserRole.GES,
//     UserRole.HOSPITALITY_MANAGER,
//     UserRole.HOUSE_KEEPING_MANAGER,
//     UserRole.OPERATION_MANAGER,
//     UserRole.COMMERCIAL_MANAGER
//   ],
//   true
// )(() => <GlobalCalendarComponent />);

const NewGlobalCalendarRender = withAuthorization(
  [
    UserRole.SUPER_ADMIN,
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <NewGlobalCalendar />);
